import { FC } from "react";
import { List } from "antd";
import "./common-popup-list-view.scss"

interface FieldConfig {
  label: string;
  key: string;
}

interface CommonPopupListViewProps {
  data: any[];
  fields: FieldConfig[];
  className?: string;
}

const CommonPopupListView: FC<CommonPopupListViewProps> = ({ data, fields, className = "popup-list" }) => {
  return (
    <List
      dataSource={data}
      renderItem={(item) => (
        <List.Item className={className}>
          <List.Item.Meta
            description={
              <>
                {fields.map((f) => (
                  <div key={f.key}>
                    <span className={`${className}__label`}>{f.label}: </span>
                    {item[f.key] ?? "--"}
                  </div>
                ))}
              </>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default CommonPopupListView;
